import { HomeScreenWidget } from '~/models'

const registry: Map<HomeScreenWidget['type'], React.ComponentType<HomeScreenWidgetProps<any>>> = new Map()

export function getHomeScreenWidgetComponent(widget: string) {
  for (const [name, Component] of registry) {
    if (name === widget) {
      return Component
    }
  }

  return null
}

export function register<O>(widget: HomeScreenWidget['type'], target: React.ComponentType<HomeScreenWidgetProps<O>>) {
  registry.set(widget, target)
}

export interface HomeScreenWidgetProps<O> {
  options: O
}